(function () {
  const OPEN_CLASS = 'size-guide--open';

  // move root to body once (in case partial rendered inside product container)
  const root = document.querySelector('[data-size-guide-root]');
  if (root && !root.hasAttribute('data-size-guide-ported')) {
    document.body.appendChild(root);
    root.setAttribute('data-size-guide-ported', 'true');
  }

  function getRoot() {
    return document.querySelector('[data-size-guide-root]');
  }

  function openGuide(rootEl) {
    if (!rootEl) return;
    rootEl.classList.add(OPEN_CLASS);
    rootEl.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const btn = rootEl.querySelector('[data-size-guide-close]');
    if (btn) btn.focus();
  }
  function closeGuide(rootEl) {
    if (!rootEl) return;
    rootEl.classList.remove(OPEN_CLASS);
    rootEl.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    const opener = document.querySelector('[data-size-guide-open]');
    if (opener) opener.focus();
  }

  /* ----------------------------
     Conversion helpers (IN -> CM)
     ---------------------------- */

  function inToCm(n) {
    return n * 2.54;
  }

  function fmtNumber(n) {
    // if nearly integer, show integer, else one decimal
    if (Math.abs(Math.round(n) - n) < 1e-9) return String(Math.round(n));
    return (Math.round(n * 10) / 10).toFixed(1);
  }

  // Convert text but return numeric-only replacements (no "cm" appended).
  // Handles ranges: "34-36" -> "86.4-91.4"
 function convertTextToCmNumericOnly(text) {
  let str = text;

  // --- 1) Convert ranges like "10in - 12in" or "10 in–12 in" ---
  const rangeRegex = /(\d+(?:\.\d+)?)\s*(?:in|inch|inches)\s*[-–]\s*(\d+(?:\.\d+)?)(?=\s*(?:in|inch|inches))/gi;
  str = str.replace(rangeRegex, (m, p1, p2) => {
    const a = inToCm(parseFloat(p1));
    const b = inToCm(parseFloat(p2));
    return `${fmtNumber(a)}–${fmtNumber(b)} cm`;
  });

  // --- 2) Convert standalone values like "10in", "10 in", "10 inches" ---
  const inchRegex = /(\d+(?:\.\d+)?)\s*(in|inch|inches)\b/gi;
  str = str.replace(inchRegex, (m, num) => {
    const cm = inToCm(parseFloat(num));
    return `${fmtNumber(cm)} cm`;
  });

  return str;
}



  // Prepare cells: store original inch text and computed cm-only text (no "cm")
function prepareTableConversions(rootEl) {
  if (!rootEl) return;
  const cells = rootEl.querySelectorAll('.size-guide__table .size-guide__row .size-guide__cell');

  cells.forEach((cell) => {
    if (cell.classList.contains('size-guide__cell--head')) return;

    const orig = cell.textContent.trim();
    cell.dataset.inch = orig;

    // Only convert if the cell text contains an inch unit
    if (/in\b|inch\b|inches\b/i.test(orig)) {
       cell.dataset.cm = convertTextToCmNumericOnly(orig);

    } else {
      // keep original if no inch units detected
      cell.dataset.cm = orig;
    }
  });
}


  // Toggle display: inches (show data-inch), or centimeters numeric-only (show data-cm)
  function toggleUnits(rootEl, showCm) {
    if (!rootEl) return;
    const cells = rootEl.querySelectorAll('.size-guide__table .size-guide__row .size-guide__cell');
    cells.forEach((cell) => {
      if (cell.classList.contains('size-guide__cell--head')) return;
      if (showCm) {
        if (cell.dataset.cm !== undefined) cell.textContent = cell.dataset.cm;
      } else {
        if (cell.dataset.inch !== undefined) cell.textContent = cell.dataset.inch;
      }
    });

    // Update root class for styling (if needed)
    if (showCm) rootEl.classList.add('units--cm');
    else rootEl.classList.remove('units--cm');

    // Update the title unit label text (the small span next to title)
    const titleUnit = rootEl.querySelector('.size-guide__title-unit');
    if (titleUnit) {
      titleUnit.textContent = showCm ? ' — in centimeters' : ' — in inches';
    }

    // Keep the toggle input state consistent
    const input = rootEl.querySelector('.units-toggle__input');
    if (input) input.checked = !!showCm;
  }

  function initConversions(rootEl) {
    if (!rootEl) return;
    prepareTableConversions(rootEl);
    // show inches by default
    toggleUnits(rootEl, false);
  }

  /* ----------------------------
     Event handling
     ---------------------------- */

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-size-guide-open]');
    if (openBtn) return openGuide(getRoot());

    if (e.target.closest('[data-size-guide-close]') || e.target.closest('[data-size-guide-overlay]')) {
      return closeGuide(getRoot());
    }

    // units toggle clicking (wrap or input)
    if (e.target.closest('.units-toggle') || e.target.classList.contains('units-toggle__input')) {
      const rootEl = getRoot();
      const input = rootEl.querySelector('.units-toggle__input');
      if (!input) return;
      if (e.target.closest('.units-toggle') && e.target !== input) input.checked = !input.checked;
      toggleUnits(rootEl, input.checked);
      return;
    }
  });

  // keyboard esc closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeGuide(getRoot());
  });

  // basic focus trap when open
  document.addEventListener('focusin', (e) => {
    const rootEl = getRoot();
    if (!rootEl || !rootEl.classList.contains(OPEN_CLASS)) return;
    if (!rootEl.contains(e.target)) {
      const first = rootEl.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
      if (first) first.focus();
    }
  });

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    const rootEl = getRoot();
    if (!rootEl) return;
    initConversions(rootEl);

    const input = rootEl.querySelector('.units-toggle__input');
    if (input) {
      input.checked = false; // default to inches
      input.addEventListener('change', () => toggleUnits(rootEl, input.checked));
    }
  });

  // Also re-run prepare when the drawer is opened (in case table content is injected later)
  const originalOpen = openGuide;
  window.__sizeGuide_open_override = function (rootEl) {
    originalOpen(rootEl);
    setTimeout(() => {
      initConversions(getRoot());
    }, 40);
  };
  // expose wrapper as a convenient function (no need to replace click handlers)
  window.openSizeGuide = window.__sizeGuide_open_override;

})();
